/* ACCESS ROLES — THE MIRROR OF config/access.js ON THE BACKEND
 *
 * A leaf module on purpose: it imports nothing at all, so every layer of the panel may read the roles without
 * dragging the translations, the store or moment along. Admins.access is the only source of truth */

/* EVERY ROLE THE COLUMN Admins.access HOLDS */
export const ROLES = ["superadmin", "manager", "pitboss", "viewer"]

/* FALLBACK ROLE OF AN ADMIN WITH AN EMPTY COLUMN — THE BACKEND NORMALIZES IT THE VERY SAME WAY */
export const DEFAULT_ROLE = "manager"

/* ACCESS TYPES ALLOWED FOR EVERY ROLE */
export const TYPES = {
    superadmin: ["view", "edit", "manage", "superadmin"],
    manager: ["view", "edit", "manage"],
    pitboss: ["view", "edit"],
    viewer: ["view"],
}

/* NORMALIZE THE ROLE OF AN ADMIN */
export const getRole = (admin) => ROLES.includes(admin && admin.access) ? admin.access : DEFAULT_ROLE

/* CHECK AN ACCESS TYPE — can(admin, "edit") */
export const can = (admin, type = "view") => TYPES[getRole(admin)].includes(type)

/* IS THE ADMIN A SUPERADMIN */
export const isSuperAdmin = (admin) => getRole(admin) === "superadmin"
